import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Phase, Release } from '../services/release.service';

@Component({
  selector: 'cohorts-column-view',
  template: `
  <span *ngFor="let phase of phases" class="cohorts-column-view">
    <span class="lx-body-bold">{{ phase.name }}: </span>
    <span class="lx-body">{{ phase.cohorts.join(', ') }} </span>
  </span>`,
  styleUrls: ['./cohorts-column-view.component.scss']
})

export class CohortsColumnViewComponent implements ICellRendererAngularComp{

  constructor() { }

  phases: Phase[];
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.phases = params.data.phases;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.phases = params.data.phases;
    return true;
  }
}